import React from "react";
import { Typography } from "@material-ui/core";
import { useSelector } from "react-redux";
import { getAppColor } from "@icarius-app/selectors";
import { formatNumberExactDecimals } from "@icarius-utils/format";
import { getLocalizedString } from "@icarius-localization/strings";

const Plan = (props) => {
    const { name, level, status, pointsToExchange, showPointsToExchange, dialog } = props;

    const color = useSelector(getAppColor);

    const getLevelMessage = () => {
        if (level === 1) return getLocalizedString("keepGettingPoints");
        if (level === 2) return getLocalizedString("starCollaborator");
        return getLocalizedString("superstarCollaborator");
    };

    return (
        <div
            style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                margin: 20,
            }}
        >
            <Typography className="whiteText" align="center" style={{ fontSize: 16, marginTop: -5 }}>
                {`${getLocalizedString("recognitionPlan")}:`}
            </Typography>
            <Typography className="whiteText" align="center" style={{ fontWeight: 600, fontSize: 18, marginBottom: 5 }}>
                {`${name} ${status === "H" ? `(${getLocalizedString("historicalLabel")})` : ""}`}
            </Typography>
            {(!dialog || showPointsToExchange) && (
                <>
                    <Typography className="whiteText" align="center" style={{ fontSize: 16 }}>
                        {`${getLocalizedString("pointsAvailableForTrade")}:`}
                    </Typography>
                    <Typography align="center" style={{ fontSize: 18, color: color, fontWeight: 600 }}>
                        {formatNumberExactDecimals(pointsToExchange, 0)}
                    </Typography>
                </>
            )}
            <Typography className="whiteText" style={{ fontWeight: 600, fontSize: 18 }}>
                {getLevelMessage()}
            </Typography>
        </div>
    );
};

export default Plan;
